import React, { useState } from 'react';

function UserMenu({ user }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    window.location.href = '/auth/logout';
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-sm text-gray-700 hover:text-gray-900 focus:outline-none"
      >
        {user.picture ? (
          <img 
            src={user.picture} 
            alt={user.name} 
            className="h-8 w-8 rounded-full border border-gray-200"
          />
        ) : (
          <div className="h-8 w-8 rounded-full bg-sage-400 flex items-center justify-center text-white font-medium">
            {user.name ? user.name[0].toUpperCase() : 'U'}
          </div>
        )}
        <span className="hidden sm:block font-medium">{user.name || user.email}</span>
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          ></div>
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 z-20 border border-gray-200">
            <div className="px-4 py-2 border-b border-gray-200">
              <p className="text-sm font-medium text-gray-900">{user.name}</p>
              <p className="text-xs text-gray-500">{user.email}</p>
            </div>
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              Sign out
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default UserMenu;